export const MENU = [
	{
		type: 'submenu',
		id: 'site',
		label: 'Содержимое страниц',
		opened: true,
		icon: 'cog',
		items: [
			{
				type: 'link',
				record: {
					href: '/admin/news',
					set: 'admin',
					// icon: '',
					label: 'Новости',
					model: 'Article',
				},
			},
			{
				type: 'link',
				record: {
					href: '/admin/direct-speech',
					set: 'admin',
					// icon: '',
					label: 'Прямая речь',
					model: 'Article',
				},
			},
			{
				type: 'link',
				record: {
					href: '/admin/expert-opinion',
					set: 'admin',
					// icon: '',
					label: 'Экспертное мнение',
					model: 'Article',
				},
			},
			{
				type: 'link',
				record: {
					href: '/admin/galleries',
					set: 'admin',
					// icon: '',
					label: 'Фоторепортажи',
					model: 'Gallery',
				},
			},
			{
				type: 'link',
				record: {
					href: '/admin/media',
					set: 'admin',
					// icon: '',
					label: 'Видео',
					model: 'Media',
				},
			},
			/*
			{
				type: 'link',
				record: {
					href: '/admin/bills',
					set: 'admin',
					// icon: '',
					label: 'Законы',
				},
			},
*/
			{
				type: 'link',
				record: {
					href: '/admin/awards',
					set: 'admin',
					// icon: '',
					label: 'Награды',
					model: 'Award',
				},
			},
			{
				type: 'link',
				record: {
					href: '/admin/media-accreditation/mediatitles',
					set: 'admin',
					// icon: '',
					label: 'Аккредитация СМИ',
					model: 'MediaAccreditation',
				},
			},
			{
				type: 'link',
				record: {
					href: '/admin/MainSlides',
					set: 'admin',
					// icon: '',
					label: 'Главный слайдер',
					model: 'MainSlide',
				},
			},
		],
	},
	{
		type: 'submenu',
		id: 'sessions',
		label: 'Заседания',
		opened: true,
		icon: 'cog',
		items: [
			{
				type: 'link',
				record: {
					href: '/admin/plenarysessions',
					set: 'admin',
					// icon: '',
					label: 'Пленарные заседания',
					model: 'PlenarySession',
					roles: ['protocolist'],
				},
			},
			{
				type: 'link',
				record: {
					href: '/admin/committeesessions',
					set: 'admin',
					// icon: '',
					label: 'Заседания комитетов',
					model: 'Committee',
				},
			},
			{
				type: 'link',
				record: {
					href: '/admin/councilsessions',
					set: 'admin',
					// icon: '',
					label: 'Заседания Совета',
					model: 'CouncilSession',
				},
			},
			{
				type: 'link',
				record: {
					href: '/admin/voting',
					set: 'admin',
					// icon: '',
					label: 'Голосование',
					model: 'Vote',
				},
			},
		],
	},
	{
		type: 'submenu',
		id: 'mainpage',
		label: 'Главная страница',
		opened: true,
		icon: 'cog',
		items: [
			{
				type: 'link',
				record: {
					href: '/admin/links',
					set: 'admin',
					// icon: '',
					label: 'Ссылки на другие сайты',
					model: 'Link',
				},
			},
			{
				type: 'link',
				record: {
					href: '/admin/ticker',
					set: 'admin',
					// icon: '',
					label: 'Бегущая строка',
					model: 'Ticker',
				},
			},
			{
				type: 'link',
				record: {
					href: '/admin/banner-home',
					set: 'admin',
					// icon: '',
					label: 'Баннер',
				},
			},
		],
	},
	{
		type: 'submenu',
		id: 'content',
		label: 'Содержание',
		opened: true,
		icon: 'cog',
		items: [
			{
				type: 'link',
				record: {
					href: '/admin/awards-information',
					set: 'admin',
					// icon: '',
					label: 'Информация о наградах',
					model: 'AwardInformation',
				},
			},
			{
				type: 'link',
				record: {
					href: '/admin/static',
					set: 'admin',
					id: 'static',
					// icon: '',
					label: 'Страницы',
					model: 'Page',
				},
			},
			{
				type: 'link',
				record: {
					href: '/admin/itogi',
					id: 'itogi',
					set: 'admin',
					// icon: '',
					label: 'Итоги',
					model: 'Itogi',
				},
			},
			{
				type: 'link',
				record: {
					href: '/admin/discussions',
					id: 'discussions',
					set: 'admin',
					// icon: '',
					label: 'Обсуждения',
					model: 'Discussion',
				},
			},
		],
	},
	{
		type: 'submenu',
		id: 'structure',
		label: 'Состав и структура',
		opened: true,
		icon: 'cog',
		items: [
			{
				type: 'link',
				record: {
					href: '/admin/governance',
					set: 'admin',
					// icon: '',
					label: 'Руководство',
					model: 'Governance',
				},
			},
			{
				type: 'link',
				record: {
					href: '/admin/committees',
					set: 'admin',
					// icon: '',
					label: 'Комитеты',
					// model: 'Committee',
					roles: ['admin', 'editor']
				},
			},
			{
				type: 'link',
				record: {
					href: '/admin/chairperson-workplan',
					set: 'admin',
					// icon: '',
					label: 'План работы председателя',
					model: 'ChairpersonWorkplan',
				},
			},
		],
	},
	{
		type: 'submenu',
		id: 'documents',
		label: 'Документы',
		opened: true,
		icon: 'cog',
		items: [
			{
				type: 'link',
				record: {
					href: '/admin/documents/laws',
					set: 'admin',
					// icon: '',
					label: 'Законы и постановления',
					model: 'BaseLaw',
				},
			},
			{
				type: 'link',
				record: {
					href: '/admin/baselaws',
					set: 'admin',
					// icon: '',
					label: 'Базовые законы',
					model: 'BaseLaw',
				},
			},
		],
	},
	{
		type: 'submenu',
		id: 'deputies',
		label: 'Депутаты',
		opened: true,
		icon: 'cog',
		items: [
			{
				type: 'link',
				record: {
					href: '/admin/deputies',
					set: 'admin',
					// icon: '',
					label: 'Депутаты',
					model: 'Deputy',
				},
			},
			{
				type: 'link',
				record: {
					href: '/admin/convocations',
					set: 'admin',
					// icon: '',
					label: 'Созывы',
					model: 'Convocation',
				},
			},
			{
				type: 'link',
				record: {
					href: '/admin/fractions',
					set: 'admin',
					// icon: '',
					label: 'Фракции',
					model: 'Fraction',
				},
			},
			{
				type: 'link',
				record: {
					href: '/admin/divisiongroups',
					set: 'admin',
					// icon: '',
					label: 'Региональные группы',
					model: 'DivisionGroup',
				},
			},
			{
				type: 'link',
				record: {
					href: '/admin/divisions',
					set: 'admin',
					// icon: '',
					label: 'Избирательные округи',
					model: 'Division',
				},
			},
			{
				type: 'link',
				record: {
					href: '/admin/appeals',
					set: 'admin',
					// icon: '',
					label: 'Обращения граждан',
					// model: 'Appeal',
					roles: ['admin', 'appeals']

				},
			},
			{
				type: 'link',
				record: {
					href: '/admin/appointments',
					set: 'admin',
					// icon: '',
					label: 'Запись на личный прием',
					// model: 'Appointment',
					roles: ['admin', 'appeals']
				},
			},
			{
				type: 'link',
				record: {
					href: '/admin/dispatches',
					set: 'admin',
					// icon: '',
					label: 'Сообщения депутатам',
					model: 'Dispatch',
					// roles: ['admin' , 'dispatches']
				},
			},
		],
	},
	{
		type: 'submenu',
		id: 'users',
		label: 'Пользователи',
		opened: true,
		icon: 'cog',
		items: [
			{
				type: 'link',
				record: {
					href: '/admin/subscriptions',
					set: 'admin',
					// icon: '',
					label: 'Подписки',
					model: 'Subscription',
				},
			},
		],
	},
	{
		type: 'submenu',
		id: 'debug',
		label: 'Debug',
		opened: true,
		icon: 'cog',
		items: [
			{
				type: 'link',
				record: {
					href: '/admin/debuglog',
					set: 'admin',
					// icon: '',
					label: 'Debug log',
					// model: 'DebugLog',
					roles: ['admin'],
				},
			},
			// {
			// 	type: 'link',
			// 	record: {
			// 		href: '/admin/rolemappingstest',
			// 		set: 'admin',
			// 		// icon: '',
			// 		label: 'Назначенные роли ТЕСТ',
			// 		// model: 'DebugLog',
			// 	},
			// },
		],
	},
];
